import { Link } from "react-router-dom"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"

/**
 * Breadcrumb reutilizable para las páginas de reporte vinculadas al Changelog.
 *
 * Estructura:  Changelog  /  <currentLabel>
 *
 * @param currentLabel  Texto de la página activa, p. ej. "Localidades · 2026-05-11"
 */
export function ChangelogReportBreadcrumb({ currentLabel }: { currentLabel: string }) {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink render={<Link to="/changelog" />}>
            Changelog
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbPage>{currentLabel}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  )
}
